var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      _vm.$route.name == 'law' ||
        _vm.$route.name == 'description' ||
        _vm.$route.name == 'search' ||
        _vm.$route.name == 'history'
    )?_c('History',{attrs:{"type":_vm.$route.name == 'search' || _vm.$route.name == 'history' ? 2 : 1}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }